import { $api } from "../generated/client";

export default function useGetShopEmbedHtmlSuspense(shopifyUrl: string) {
	return $api.useSuspenseQuery("get", "/embed-html", {
		params: { query: { shopifyUrl } },
	});
}
